export function Currencies({ kamas, reflets, ogrines }: { kamas: number; reflets: number; ogrines: number }) {
  return (
    <div class="hud-currencies" aria-label="Monnaies">
      <span class="currency"><img src="/assets/icons/ui/kamas.png" alt="" /> {kamas} <small>Kamas</small></span>
      <span class="currency"><img src="/assets/icons/ui/reflets.png" alt="" /> {reflets} <small>Reflets</small></span>
      <span class="currency"><span class="ogrine-badge" aria-hidden="true">O</span> {ogrines} <small>Ogrines</small></span>
    </div>
  );
}
